import { apiFetch } from "@/integrations/backend/client";

export interface ClientFileDto {
  id: string;
  name: string | null;
  url: string | null;
  uploadedAt: string | null;
  createdByProfileId: string | null;
}

export async function listMyFiles(): Promise<ClientFileDto[]> {
  const res = await apiFetch("/api/v1/files/me", { method: "GET" });
  if (!res.ok) throw new Error(`files_me_list_failed:${res.status}`);
  return (await res.json()) as ClientFileDto[];
}

export async function uploadMyFile(file: File, type: string = "file", name?: string): Promise<ClientFileDto> {
  const form = new FormData();
  form.append("file", file);
  form.append("type", type);
  form.append("name", (name ?? "").trim() || file.name);
  const res = await apiFetch("/api/v1/files/me", { method: "POST", body: form });
  if (!res.ok) throw new Error(`files_me_upload_failed:${res.status}`);
  return (await res.json()) as ClientFileDto;
}

export async function deleteMyFile(fileId: string): Promise<void> {
  const res = await apiFetch(`/api/v1/files/me/${encodeURIComponent(fileId)}`, { method: "DELETE" });
  if (!res.ok) throw new Error(`files_me_delete_failed:${res.status}`);
}

export async function adminListClientFiles(clientProfileId: string): Promise<ClientFileDto[]> {
  const res = await apiFetch(`/api/v1/admin/clients/${encodeURIComponent(clientProfileId)}/files`, { method: "GET" });
  if (!res.ok) throw new Error(`admin_client_files_list_failed:${res.status}`);
  return (await res.json()) as ClientFileDto[];
}

export async function adminUploadClientFile(
  clientProfileId: string,
  file: File,
  type: string = "file",
  name?: string
): Promise<ClientFileDto> {
  const form = new FormData();
  form.append("file", file);
  form.append("type", type);
  form.append("name", (name ?? "").trim() || file.name);
  const res = await apiFetch(`/api/v1/admin/clients/${encodeURIComponent(clientProfileId)}/files`, {
    method: "POST",
    body: form,
  });
  if (!res.ok) throw new Error(`admin_client_files_upload_failed:${res.status}`);
  return (await res.json()) as ClientFileDto;
}

export async function adminDeleteClientFile(clientProfileId: string, fileId: string): Promise<void> {
  const res = await apiFetch(
    `/api/v1/admin/clients/${encodeURIComponent(clientProfileId)}/files/${encodeURIComponent(fileId)}`,
    { method: "DELETE" }
  );
  if (!res.ok) throw new Error(`admin_client_files_delete_failed:${res.status}`);
}


